// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step5-review-container {
    padding: 2rem;
}

.review-section {
    margin-bottom: 1.5rem;
}

.review-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.review-data {
    background: #f7f7f7;
    padding: 1rem;
    border-radius: 6px;
    font-size: 0.9rem;
    overflow-x: auto;
}

.final-submit {
    display: flex;
    justify-content: flex-end;
    margin-top: 2rem;
}

.submit-btn {
    background-color: #1976d2;
    color: white;
    padding: 0.7rem 1.5rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

    .submit-btn:hover {
        background-color: #125ea6;
    }
.summary-card {
    background: #f9f9f9;
    padding: 1.2rem;
    border-radius: 8px;
    box-shadow: 0 0 4px rgba(0,0,0,0.1);
    margin-bottom: 1.5rem;
}

.summary-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/PortCall/Step5ReviewSubmit.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;IAEI;QACI,yBAAyB;IAC7B;AACJ;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".step5-review-container {\n    padding: 2rem;\n}\n\n.review-section {\n    margin-bottom: 1.5rem;\n}\n\n.review-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.review-data {\n    background: #f7f7f7;\n    padding: 1rem;\n    border-radius: 6px;\n    font-size: 0.9rem;\n    overflow-x: auto;\n}\n\n.final-submit {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 2rem;\n}\n\n.submit-btn {\n    background-color: #1976d2;\n    color: white;\n    padding: 0.7rem 1.5rem;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n    .submit-btn:hover {\n        background-color: #125ea6;\n    }\n.summary-card {\n    background: #f9f9f9;\n    padding: 1.2rem;\n    border-radius: 8px;\n    box-shadow: 0 0 4px rgba(0,0,0,0.1);\n    margin-bottom: 1.5rem;\n}\n\n.summary-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
